// ./pages/About/index.jsx
import React from "react";
// import CancellationPolicySubBanner from "../../components/CancellationPolicyBanner/index";
import Shopsubbanner from "../../components/shopsubbanner";
import CancellationPolicy from "../../components/CancellationPolicy";

const Cancellation = () => {
  return (
    <>
     <Shopsubbanner
        title="Cancellation Policy"
        image_url="https://res.cloudinary.com/dtivafy25/image/upload/v1749818243/Derby_02_tdim28.jpg" />
     <CancellationPolicy />
    </>
  );
};

export default Cancellation;
